import { Typography } from '@mui/material';

const colorContainer = (value) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor:
    value === 'SIM' ? '#baffc9' : value === 'NAO' ? '#ffb3ba' : '#ffffba',
});

const columnOverrides = [
  {
    field: 'ativo',
    renderCell: ({ value }) => (
      <div style={colorContainer(value)}>
        <span>{value}</span>
      </div>
    ),
  },
  {
    field: 'preco',
    valueGetter: ({ value }) =>
      value && value.toLocaleString('pt-br', { minimumFractionDigits: 2 }),
  },
  {
    field: 'descricao',
    renderCell: ({ value }) => (
      <Typography
        variant="body2"
        sx={{ textDecoration: 'underline', cursor: 'pointer' }}
      >
        {value}
      </Typography>
    ),
  },
];

export default columnOverrides;
